import { PhysicalContractDeliveryType } from '@enechain/eposition-proto/bfftypes/v1/contract_pb'
import { DeliveryType } from '@enechain/eposition-proto/types/v1/deal_pb'

export function convertPhysicalContractDeliveryTypeToDeliveryType(
  physicalDeliveryType: PhysicalContractDeliveryType | undefined,
): DeliveryType {
  switch (physicalDeliveryType) {
    case PhysicalContractDeliveryType.BG:
      return DeliveryType.BG
    case PhysicalContractDeliveryType.JEPX:
      return DeliveryType.JEPX
    case PhysicalContractDeliveryType.UNSPECIFIED:
    case undefined:
    default:
      return DeliveryType.UNSPECIFIED
  }
}
